var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-aside-container"},[_c('Avatar',{attrs:{"url":_vm.data && _vm.data.avatar}}),_c('Menu'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }